import React__default, { useCallback, useEffect } from 'react';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Cross, Menu } from '@sravni/react-icons';
import { useStyles, preventBodyScroll } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { defaultMobileMenu } from '../../../mocks/defaultMobileMenu.js';
import { HiddenLinks } from '../../HiddenLinks/src/HiddenLinks.js';
import { MobileMenu } from '../../MobileMenu/src/MobileMenu.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import '../../Providers/MenuVisibilityProvider/src/MenuVisibilityProvider.js';
import { useMenuVisibility } from '../../Providers/MenuVisibilityProvider/hooks/useMenuVisibility.js';
import modules_5e29803a from '../styles/MobileMenuBlock.module.less.js';

const MobileMenuBlock = (props) => {
    const { promo, settings = {} } = useCustomProps();
    const { mobileMenu: menu = defaultMobileMenu } = settings;
    const { pushAnalyticEvent } = useAnalyticEvents();
    const cx = useStyles(modules_5e29803a);
    const [isVisibleMenu, setIsVisibleMenu] = useMenuVisibility();
    const handleUserDropdownButtonCloseClick = useCallback(() => {
        setIsVisibleMenu(false);
        pushAnalyticEvent("mobileBurgerClick" /* EVENTS.MOBILE_BURGER_CLICK */, { eventLabel: `Закрытие` });
    }, [pushAnalyticEvent, setIsVisibleMenu]);
    const handleUserDropdownButtonOpenClick = useCallback(() => {
        setIsVisibleMenu(true);
        pushAnalyticEvent("mobileBurgerClick" /* EVENTS.MOBILE_BURGER_CLICK */, { eventLabel: `Открытие` });
    }, [pushAnalyticEvent, setIsVisibleMenu]);
    const handlePromoBannerClick = React__default.useCallback(() => {
        pushAnalyticEvent("promoBannerClick" /* EVENTS.PROMO_BANNER_CLICK */);
    }, [pushAnalyticEvent]);
    useEffect(() => {
        preventBodyScroll(isVisibleMenu);
        return () => preventBodyScroll();
    }, [isVisibleMenu]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Space, { align: "center", "data-qa": "MobileMenuBlock", ...props },
            React__default.createElement(Button, { size: 36, variant: "secondary", color: "dark", className: cx('triggerButton'), onClick: isVisibleMenu ? handleUserDropdownButtonCloseClick : handleUserDropdownButtonOpenClick },
                React__default.createElement(Icon, { icon: isVisibleMenu ? React__default.createElement(Cross, null) : React__default.createElement(Menu, null) }))),
        React__default.createElement("div", { className: cx('dropdown', { dropdownVisible: isVisibleMenu }) },
            React__default.createElement(HiddenLinks, { menu: menu }),
            isVisibleMenu && React__default.createElement(MobileMenu, null),
            promo ? (React__default.createElement("div", { className: cx('promoWrapper'), onClickCapture: handlePromoBannerClick }, promo)) : null)));
};
MobileMenuBlock.displayName = 'MobileMenuBlock';

export { MobileMenuBlock };
//# sourceMappingURL=MobileMenuBlock.js.map
